import { connect } from 'react-redux';
import giftCardinfoModule from 'app/store/giftcards';
import storage from 'app/services/storage';
import GiftCardInfo from './GiftCardInfo.component';

const {
  giftLocationInfoRequest,
  setGiftLocationInfoContent,
  requestForCinemasWithMovies,
  setDates,
  requestDates,
  requestContentData
} = giftCardinfoModule.actions;

const mapStateToProps = ({ layout, cinemas, giftcards }) => ({
  locations: layout.locations,
  isLoading: layout.isLoading,
  dates: cinemas.dates,
  cinemas: cinemas.cinemas,
  content: giftcards.content,
  savedLocation: storage.getLocation()
});

const mapDispatchToProps = {
  requestContent: requestContentData,
  fetchLocation: giftLocationInfoRequest,
  clearState: setGiftLocationInfoContent,
  getchLocationCinemas: requestForCinemasWithMovies,
  getDates: requestDates,
  setDates
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GiftCardInfo);
